module.exports = __webpack_public_path__ + "static/cashew_nuts_co_mai_2-76f055884974675f9b2196f34c1ece2c.jpg";